<template>
  <FormClient />
</template>

<script>
import FormClient from '@/components/Form/Client'
export default {
  components: {
    FormClient,
  },
  theme() {
    return {
      title: 'Ajouter un nouveau client',
      subtitle: '',
    }
  },
}
</script>

<style></style>
